module.exports = __webpack_public_path__ + "static/media/white_bishop.c20ae378.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pieces/white_bishop.png
// module id = 155
// module chunks = 0